import { useRef } from 'react';

import { useOuterClick } from '@nf/utils-common/hooks';
import { useAccordionDropdownContext } from '../contexts/accordion-dropdown-context';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from '../../accordion';

export const GroupOptionsAccordion = () => {
	const { 
		groupItems, 
		valueGroup, 
		closeMenu, 
		indicatorIcon, 
		getOptionProps 
	} = useAccordionDropdownContext();
	const accordionRef = useRef<HTMLElement>(null);
	
	useOuterClick(accordionRef, closeMenu);

	return (
		<Accordion 
			ref={accordionRef}
			className="dropdown__container"
			expandedItemKeys={valueGroup ? [valueGroup] : []}
		>
			<div className="scrollbar">
				{groupItems.map((groupItem) => (
					<AccordionItem 
						key={groupItem.group}
						itemKey={groupItem.group}
					>
						<AccordionHeader>
							<span className="accordion__btn-text">{groupItem.group}</span>
							{indicatorIcon}
						</AccordionHeader>
						<AccordionBody>
							{groupItem.options.map(option => (
								<div
									key={option.label} 
									className="dropdown__item"
									{...getOptionProps(groupItem, option)}
								>
									<span className="dropdown__item-text">{option.label}</span>
								</div>
							))}
						</AccordionBody>
					</AccordionItem>
				))}
			</div>
		</Accordion>
	);
};